<template>
  <div class="preview"
    @click="closeFn($event)">
    <div :class="[phoneName, 'box_phone']">
      <i class="el-icon-error close"
         @click="closeFn($event)"></i>
      <div class="preview-code" v-if="objId">
        <vue-q-art :config="obj.configs" ></vue-q-art>
        <div class="warn-info">
          <p>微信扫一扫</p>
          <p>查看手机预览效果</p>
        </div>
      </div>
      <div class="box">
        <div class="box_header">
          <div class="title">文章标题文字</div>
          <div class="box_doc">
            <div class="name">互亿编辑器</div>
            <div class="time">{{ time }}</div>
          </div>
        </div>
        <div v-html="preview_value">{{objId}}</div>
      </div>
      <ul class="box_btn">
        <li v-for="(item, key) in phone"
            :key="key"
            :class="{ active: active_idx == key }"
            @click="activeFn(key)">
          {{ item.content }}
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import VueQArt from 'vue-qart'

export default {
  data() {
    return {
      obj: {
        configs: {
          value: '888',
          imagePath: require('../assets/images/logo.png'),
          filter: 'color',
          size: 500
        },
      },
      title: "文章的标题文字",
      issue: "互亿编辑器",
      time: "2019-2-25",
      active_idx: 0,
      phoneName: "phone0",
      name: "comPreview",
      phone: [
        { content: "4.7寸", class: "small" },
        { content: "5.0寸", class: "medium" },
        { content: "5.5寸", class: "plus" }
      ],
    };
  },
  props: ['preview_value', 'objId'],
  components: {
    VueQArt
  },
  watch: {
    objId (n, o) {
      this.obj.configs.value = n.url
      console.log(this.obj.configs.value)
    }
  },
  mounted() {
    console.log(this.objId, 67)
    this.time = (function formatDate(date) {
      var y = date.getFullYear();
      var m = date.getMonth() + 1;
      m = m < 10 ? "0" + m : m;
      var d = date.getDate();
      d = d < 10 ? "0" + d : d;
      return y + "-" + m + "-" + d;
    })(new Date());
  },
  methods: {
    activeFn(idx) {
      this.active_idx = idx;
      this.phoneName = `phone${idx}`;
    },
    closeFn(e) {
      if (
        e.target.className == "preview" ||
        e.target.className.indexOf("close") != -1
      ) {
        this.$emit("close_preview");
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.preview {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 1000;
  background-color: rgba(0, 0, 0, .85);
  display: flex;
  float: left;
  justify-content: center;
  align-items: center;
  .box_phone {
    position: relative;
    background-size: 100% 100%;
    background-repeat: no-repeat;
    box-sizing: border-box;
  }
  .preview-code{
    position: absolute;
    left: -260px;
    background: #fff;
    z-index: 10000;
    padding: 10px;
    text-align: center;
     .warn-info{
       font-size: 12px;
        p{
          color: #535353;
        }
        p:first-child{
          margin-bottom:5px;
        }
     }
  }
  .box {
    overflow-y: scroll;
    height: 86.5%;
    padding: 0 14px;
  }

  .box::-webkit-scrollbar-track:hover {
    box-shadow: none;
    background-color: transparent;
  }
  // .box::-webkit-scrollbar {
  //   display: none;
  // }

  .box_header {
    margin-bottom: 15px;
  }
  .box_doc {
    display: flex;
    float: left;
    align-items: center;
    .name {
      color: #576b93;
      font-size: 12px;
    }
    .time {
      color: #b2b2b2;
      font-size: 12px;
      margin-left: 10px;
    }
  }

  .title {
    font-size: 20px;
    color: #222222;
    line-height: 50px;
  }

  .phone0 {
    width: 290px;
    height: 586px;
    padding: 115px 21px 10px;
    background-image: url(../assets/images/iPhone2.png);
  }
  .phone1 {
    width: 333px;
    height: 675px;
    padding: 140px 23px 10px;
    background-image: url(../assets/images/iPhone2.png);
  }
  .phone2 {
    width: 370px;
    height: 750px;
    padding: 92px 22px 10px;
    background-image: url(../assets/images/iPhoneX.png);
    .box {
      padding: 10px 14px 0;
      height: 95%;
      box-sizing: border-box;
    }
  }
  .close {
    position: absolute;
    right: -50px;
    color: #ffffff;
    font-size: 30px;
    top: 20px;
    display: block;
    cursor: pointer;
  }
  .close:hover{
    color: #45bf24;
  }
  .box_btn {
    position: absolute;
    right: -120px;
    top: 50%;
    transform: translateY(-50%);
    width: 100px;
    li {
      width: 100%;
      margin: 5px 0;
      color: #535353;
      background-color: #ffffff;
      text-align: center;
      line-height: 34px;
      border-radius: 5px;
      cursor: pointer;
      &:hover {
        color: #ffffff;
        background-color: $color;
      }
      &.active {
        color: #ffffff;
        background-color: $color;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/com-preview.vue